import { array, enums, number, object, string } from "superstruct";

import { ICON_SIZES } from "../constants/constants";

export const RewardsIconSizeSchema = object({
    method: string(),
    w: number(),
    h: number(),
    url: string(),
    label: enums(Object.values(ICON_SIZES)),
});

export const RewardsIconSchema = object({
    url: string(),
    sizes: array(RewardsIconSizeSchema),
});
